import { render, staticRenderFns } from "./StoreEmployee.vue?vue&type=template&id=87b6a476&scoped=true"
import script from "./StoreEmployee.vue?vue&type=script&lang=js"
export * from "./StoreEmployee.vue?vue&type=script&lang=js"
import style0 from "./StoreEmployee.vue?vue&type=style&index=0&id=87b6a476&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b6a476",
  null
  
)

export default component.exports